import './Admin-login.css';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import ThemeSwitch from '../../Components/themeSwitch/themeSwitch';
import OTPInputWithTimer from '../../Components/OTPInput/otpInputField';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  setUsername,
  setUserIdStore,
  setIsInvitee,
  setIsInviteeDirector,
  setIsBusiness,
  setRoleName,
  setUserStatus,
  setEDDStatus,
  setSurveyStatus,
  setClientId,
  setForcedPassword,
  setAuthInitialized,
  setPendingTraining,
  setAvailableRoleList,
  setIsBusinessOwner,
  setFirstName,
  clearFirstName,
  setLastName,
  clearLastName,
} from '../../Redux/store/userSlice';
import { debounce } from 'lodash';
import WebSocketComponent from './websocket';
import CustomerLeftPanel from '../../Components/CustomerLeftPanel/customer-left-panel';
import { changeCardFalse } from '../../Redux/store/selectedCard';
import { useToast } from '../../Utils/toastContext';
import { initializeTokens } from '../../Utils/tokenManager';
import { motion, AnimatePresence } from 'framer-motion';
import { useSelector } from 'react-redux';
import ResendOptions from '../../Components/OTPInput/resent-auth-code';
import { setIndividualAccountType } from '../../Redux/store/onboardingFormSlice';
import { setApplicationType } from '../../Redux/store/accountTypeSlice';
import ContactUs from '../../Pages/Contact-Us/contact-us';
import { User, Shield, Briefcase, CheckCircle2 } from 'lucide-react';
import VerificationCode from './email-verification-screen';
const roleConfig = {
  agent: {
    label: 'Team Members',
    icon: User,
    bg: 'bg-blue-50',
    color: 'text-blue-600',
    border: 'border-blue-200',
  },
  agency: {
    label: 'Business Owner',
    icon: Briefcase,
    bg: 'bg-indigo-50',
    color: 'text-indigo-600',
    border: 'border-indigo-200',
  },
  agency_compliance: {
    label: 'Compliance Officer',
    icon: Shield,
    bg: 'bg-emerald-50',
    color: 'text-emerald-600',
    border: 'border-emerald-200',
  },
  customer: {
    label: 'Customer',
    icon: User,
    bg: 'bg-purple-50',
    color: 'text-purple-600',
    border: 'border-purple-200',
  },
};
const AdminLogin = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const intervalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [emailStep, setEmailStep] = useState(false);
  // TWO_FACTOR_TYPE from the API. mobile_app = old app approval flow, email_otp = OTP on web
  const [twoFactorType, setTwoFactorType] = useState('mobile_app');
  const [mobileOtpStep, setMobileOtpStep] = useState(false);
  const [loginMaskedPhone, setLoginMaskedPhone] = useState('');
  const [loginNeedsMobileVerification, setLoginNeedsMobileVerification] =
    useState(false);
  const verifiedLoginResponseRef = useRef(null);

  const [isRecoveryCodeOption, setIsRecoveryCodeOption] = useState(false);
  const [isAuthCode, setIsAuthCode] = useState(false);
  const [handshakeApproved, sethandshakeApproved] = useState(false);
  const [emailVerfied, setEmailVerfied] = useState(false);
  const [userId, setUserId] = useState(null);
  const [socketToken, setSocketToken] = useState(null);
  const isMobile = window.innerWidth < 768;
  const [isSupportOpen, setIsSupportOpen] = useState(false);
  const [loginResponse, setLoginResponse] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [otp, setOtp] = useState('');
  const [authAppCode, setAuthAppCode] = useState('');
  const [authCode, setAuthCode] = useState(new Array(6).fill(''));
  const [maskedMobile, setMaskedMobile] = useState('');
  const [selectedOption, setSelectedOption] = useState(1);
  const [showAppPopup, setShowAppPopup] = useState(false);
  const [androidImage, setAndroidImage] = useState('');
  const [IOSImage, setIOSImage] = useState('');
  const roleName = useSelector((state) => state.user.roleName);
  const dispatch = useDispatch();
  const location = useLocation();
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData('text').slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      setAuthCode(pasteData.split(''));
    }
    event.preventDefault();
  };
  useEffect(() => {
    const { passwordReset } = location.state || {};
    if (passwordReset) {
      showToast('Password Reset Successful!', 'success');
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);
  const options = [
    {
      id: 1,
      label: `${maskedMobile}`,
      checkedIcon: '/tick-circle-blue.svg',
      uncheckedIcon: '/tick-empty-blue.svg',
      secondImage: '/mobile.svg',
      name: 'Mobile Number',
    },
    {
      id: 2,
      label: `${email}`,
      checkedIcon: '/tick-circle-blue.svg',
      uncheckedIcon: '/tick-empty-blue.svg',
      secondImage: '/sms.svg',
      name: 'Email',
    },
    {
      id: 3,
      label: 'Recovery Code [ONE TIME USE]',
      checkedIcon: '/tick-circle-blue.svg',
      uncheckedIcon: '/tick-empty-blue.svg',
      secondImage: '/lock.svg',
      name: 'Recovery Code',
    },
  ];
  const navigate = useNavigate();

  const handleChange = (id) => {
    setSelectedOption(id);
  };

  const handletryAuthCode = (e) => {
    e.preventDefault();
    setIsAuthCode(true);
  };
  const handletryRecoveryCode = (e) => {
    e.preventDefault();
    setIsAuthCode(false);
    setIsRecoveryCodeOption(true);
  };
  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const postLoginAPI = async (email, password) => {
    const apiUrl = `${BASE_URL}/api/v1/auth/login`;
    const bodyData = {
      email_address: email,
      password: password,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const proceedAfterLogin = async (response, roleName) => {
    dispatch(setRoleName(roleName));
    //  dispatch(setRoleName('auditor'));

    dispatch(setUserIdStore(response.data.user_id));

    // 👉 continue your existing navigation logic here
    localStorage.setItem('lastActivity', Date.now().toString());
    localStorage.setItem('systemToken', response.data.session_id);
    dispatch(setAuthInitialized(false));
    dispatch(setUserStatus(response.data.status));
    dispatch(setForcedPassword(response.data.enforce_password_reset));
    dispatch(setIsBusinessOwner(response.data.is_original_agency_owner));
    setLoading(false);
    dispatch(changeCardFalse());
    const profileData = await getProfilePicture(response.data.access_token);
    let haspendingTrining = false;
    if (roleName === 'customer') {
      dispatch(setEDDStatus(profileData.has_pending_edd));
    }
    if (roleName === 'agency' || roleName === 'agency_compliance') {
      dispatch(setSurveyStatus(profileData.has_pending_survey));
    }
    if (roleName === 'agent' || roleName === 'agency_compliance') {
      dispatch(setPendingTraining(profileData.has_pending_training));
    }
    dispatch(setAuthInitialized(true));
    const savedRedirect = sessionStorage.getItem('redirectAfterLogin');
    if (savedRedirect) {
      console.log('saved url ' + savedRedirect);

      const { path, state } = JSON.parse(savedRedirect);
      // Prevent active users going back to onboarding
      if (response.data.status === 'active' && path === '/onboarding') {
        sessionStorage.removeItem('redirectAfterLogin');
        localStorage.setItem('sideOption', 1);
        navigate('/');
      } else {
        navigate(path, { state });
        sessionStorage.removeItem('redirectAfterLogin');
      }
    } else {
      console.log('saved url no ' + savedRedirect);

      if (response.data.status === 'active') {
        navigate('/');
      } else {
        console.log(
          'Navigating to onboarding due to userStatus:',
          response.data.status,
        );
        navigate('/onboarding');
      }
    }
  };
  const GetAPIcalls = async (url) => {
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === 'object' && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const GetAPIcallsWithToken = async (url, token) => {
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === 'object' && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getProfilePicture = async (token) => {
    try {
      const response = await GetAPIcallsWithToken('/api/v1/users/me', token);

      if (response.status == 200) {
        return response.data;
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getQRImages = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/settings/app-qr-codes`);
      if (response.status == 200) {
        setAndroidImage(response.data.android);
        setIOSImage(response.data.ios);
        setTimeout(() => {
          setShowAppPopup(true);
          setFormSubmitted(true);
        }, 700);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem('jwtToken');
        navigate('/login');
        setShowAppPopup(false);
      }
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);
  // Ask the API which second step is switched on, the login response
  // also carries it so this is mostly for knowing it early
  useEffect(() => {
    const loadTwoFactorType = async () => {
      try {
        const response = await fetch(`${BASE_URL}/api/v1/auth/two-factor-type`);
        const body = await response.json();
        if (response.ok && body?.data?.two_factor_type) {
          setTwoFactorType(body.data.two_factor_type);
        }
      } catch (err) {
        // older API without this endpoint, we just stay on the mobile app flow
        console.log('Two factor type not available, using mobile app flow');
      }
    };
    loadTwoFactorType();
  }, [BASE_URL]);

  // ── Email OTP login (TWO_FACTOR_TYPE = email_otp) ─────────────
  const postLoginOtpRequest = async (path, bodyData) => {
    const response = await fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(bodyData),
    });
    const body = await response.json().catch(() => ({
      message: 'An unexpected error occurred',
    }));
    if (!response.ok) {
      throw new Error(body.message || 'Something went wrong');
    }
    return body;
  };

  const sendLoginOtpCode = (loginUserId, loginSessionId, method) =>
    postLoginOtpRequest('/api/v1/auth/send-mfa-code', {
      user_id: loginUserId,
      session_id: loginSessionId,
      method: method,
    });

  // login session is only 5 minutes, when it runs out send the user back to the form
  const resetLoginWhenSessionExpired = (err) => {
    const message = (err?.message || '').toLowerCase();
    if (!message.includes('expired session')) {
      return;
    }
    setEmailStep(false);
    setMobileOtpStep(false);
    setFormSubmitted(false);
    showToast('Your login session expired, please log in again.', 'error');
  };

  const verifyLoginOtpCode = async (code, method) => {
    try {
      const body = await postLoginOtpRequest('/api/v1/auth/verify-mfa-code', {
        user_id: userId,
        session_id: sessionId,
        code: code,
        method: method,
      });
      // keep the tokens for the onVerify step, the code screen only needs to know it passed
      verifiedLoginResponseRef.current = body;
    } catch (err) {
      resetLoginWhenSessionExpired(err);
      throw err;
    }
  };

  const resendLoginOtpCode = async (method) => {
    try {
      await sendLoginOtpCode(userId, sessionId, method);
    } catch (err) {
      resetLoginWhenSessionExpired(err);
      throw err;
    }
  };

  // Same hand off the TOTP / app approval login does once tokens are issued
  const finishEmailOtpLogin = (verifiedResponse) => {
    // verify-mfa-code does not send session_id back and proceedAfterLogin stores it
    const loginResult = {
      ...verifiedResponse,
      data: { ...verifiedResponse.data, session_id: sessionId },
    };
    setLoginResponse(loginResult);

    if (loginResult.data.last_name != null) {
      dispatch(
        setUsername(
          loginResult.data.first_name + ' ' + loginResult.data.last_name,
        ),
      );
      dispatch(setFirstName(loginResult.data.first_name));
      dispatch(setLastName(loginResult.data.last_name));
    } else {
      dispatch(setUsername(loginResult.data.first_name));
      dispatch(setFirstName(loginResult.data.first_name));
    }
    dispatch(setUserIdStore(loginResult.data.user_id));
    localStorage.setItem('jwtToken', loginResult.data.access_token);
    localStorage.setItem('refreshJwtToken', loginResult.data.refresh_token);

    const roles = loginResult.data.roles || [];
    if (roles.length === 1) {
      dispatch(setRoleName(roles[0].name));
      dispatch(setAvailableRoleList(roles));
      proceedAfterLogin(loginResult, roles[0].name);
    } else {
      setAvailableRoles(roles);
      dispatch(setAvailableRoleList(roles));
      setShowRoleModal(true);
    }
  };

  const handleLoginEmailVerified = async () => {
    const verifiedResponse = verifiedLoginResponseRef.current;
    if (!verifiedResponse) {
      return;
    }
    // user never finished mobile verification at sign up, so we do it here before letting them in
    if (loginNeedsMobileVerification) {
      try {
        await sendLoginOtpCode(userId, sessionId, 'sms');
        showToast('OTP sent to your mobile number', 'success');
      } catch (err) {
        showToast(err.message, 'error');
      }
      setEmailStep(false);
      setMobileOtpStep(true);
      return;
    }
    finishEmailOtpLogin(verifiedResponse);
  };

  const handleLoginMobileVerified = () => {
    if (verifiedLoginResponseRef.current) {
      finishEmailOtpLogin(verifiedLoginResponseRef.current);
    }
  };
  const handleSubmit = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postLoginAPI(email, password);
        if (response.status === 200) {
          console.log('Login successful');
          // login response wins over the value we fetched on page load
          const activeTwoFactorType =
            response.data.two_factor_type || twoFactorType;
          setTwoFactorType(activeTwoFactorType);
          setUserId(response.data.user_id);
          setSocketToken(response.data.socket_token);
          setSessionId(response.data.session_id);
          setMaskedMobile(response.data.masked_phone_number);
          dispatch(setIsInvitee(response.data.invitee_context.is_invitee_user));
          dispatch(setApplicationType(response.data.account_type_id));
          dispatch(setIndividualAccountType(response.data.account_type_id));
          dispatch(setClientId(response.data.client_id));
          dispatch(setIsBusiness(true));

          //for auth code
          localStorage.setItem('jwtToken', response.data.code);
          localStorage.setItem('lastActivity', Date.now().toString());
          dispatch(setForcedPassword(response.data.enforce_password_reset));
          dispatch(setIsBusinessOwner(response.data.is_original_agency_owner));

          if (activeTwoFactorType === 'email_otp') {
            // no mobile app needed, send the email code and show the code screen
            setLoginMaskedPhone(response.data.masked_phone || '');
            setLoginNeedsMobileVerification(
              response.data.mobile_number_verified === false,
            );
            verifiedLoginResponseRef.current = null;
            await sendLoginOtpCode(
              response.data.user_id,
              response.data.session_id,
              'email',
            );
            setMobileOtpStep(false);
            setFormSubmitted(true);
            setEmailStep(true);
            toastMessage = {
              message: 'OTP sent to your email',
              type: 'success',
            };
          } else {
            // mobile_app, same as before: approve the sign in from the Ratified app
            setFormSubmitted(true);
            sethandshakeApproved(true);
            if (intervalRef.current) clearInterval(intervalRef.currenot);
          }
          //end here
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
        setFormSubmitted(false);
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [email, password, twoFactorType], // Dependencies
  );
  const postSwitchAPI = async (roleid) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/auth/acting-role/exchange`;
    const bodyData = {
      role_id: roleid,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleUpdateSwtich = useCallback(
    debounce(async (e, rolename, roleid) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postSwitchAPI(roleid);
        if (response.status === 200) {
          proceedAfterLogin(loginResponse, rolename);
          localStorage.setItem('jwtToken', response.data.access_token);
          localStorage.setItem('refreshJwtToken', response.data.refresh_token);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
        setFormSubmitted(false);
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [loginResponse], // Dependencies
  );
  useEffect(() => {
    // the 2 digit app approval code is only for the mobile_app flow
    if (userId && sessionId && twoFactorType !== 'email_otp') {
      GetAuthCode(userId, sessionId);
    }
  }, [userId, sessionId, twoFactorType]);
  const PostAuthCode = async (userId, sessionId) => {
    const apiUrl = `${BASE_URL}/api/v1/auth/create-auth-code`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const GetAuthCode = useCallback(
    debounce(async () => {
      let toastMessage = null;
      try {
        const response = await PostAuthCode(userId, sessionId);
        if (response.status === 200) {
          setAuthAppCode(response.data.code);
          setFormSubmitted(true);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: 'error' };
        setFormSubmitted(false);
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [userId, sessionId], // Dependencies
  );
  const postLoginSubmitted = async (userId, otp) => {
    let methodId = options.find((o) => o.id === selectedOption).id;
    const apiUrl = `${BASE_URL}/api/v1/auth/verify-mfa-code`;
    const bodyData = {
      user_id: userId,
      code: otp,
      session_id: sessionId,
      method: methodId == 1 ? 'sms' : 'email',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSubmitMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message

      try {
        const response = await postLoginSubmitted(userId, otp);
        if (response.status == 200) {
          // Create user info object for storage
          const userInfo = {
            userId: response.data.user_id,
            firstName: response.data.first_name,
            lastName: response.data.last_name,
            fullName: response.data.first_name + ' ' + response.data.last_name,
            email: response.data.email_address || '',
            role: response.data.role || '',
          };

          // Initialize token manager with user data
          initializeTokens(
            response.data.access_token,
            response.data.refresh_token,
            userInfo,
          );

          // Update Redux store
          if (response.data.last_name != null) {
            dispatch(
              setUsername(
                response.data.first_name + ' ' + response.data.last_name,
              ),
            );
            dispatch(setFirstName(response.data.first_name));
            dispatch(setLastName(response.data.last_name));
          } else {
            dispatch(setUsername(response.data.first_name));
            dispatch(setFirstName(response.data.first_name));
          }
          dispatch(setUserIdStore(response.data.user_id));

          // Set standard token variables for backward compatibility
          localStorage.setItem('jwtToken', response.data.access_token);
          localStorage.setItem('refreshJwtToken', response.data.refresh_token);
          localStorage.setItem('lastActivity', Date.now().toString());
          localStorage.setItem('sideOption', 1);
          dispatch(changeCardFalse());

          navigate('/');
        } else {
          toastMessage = { message: response.message, type: 'error' };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [otp, userId, sessionId], // Dependencies
  );
  const postSubmitAuthAppCode = async (userId, sessionId, authCode) => {
    const apiUrl = `${BASE_URL}/api/v1/auth/verify-totp`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
      totp_code: authCode.join(''),
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSubmitAuthAppCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message

      try {
        const response = await postSubmitAuthAppCode(
          userId,
          sessionId,
          authCode,
        );
        if (response.status == 200) {
          setLoginResponse(response); // ✅ STORE IT HERE

          if (response.data.last_name != null) {
            dispatch(
              setUsername(
                response.data.first_name + ' ' + response.data.last_name,
              ),
            );
            dispatch(setFirstName(response.data.first_name));
            dispatch(setLastName(response.data.last_name));
          } else {
            dispatch(setUsername(response.data.first_name));
            dispatch(setFirstName(response.data.first_name));
          }
          dispatch(setUserIdStore(response.data.user_id));
          const roles = response.data.roles || [];
          // const roles = [
          //   {
          //     id: 5,
          //     name: "agency",
          //   },
          //   {
          //     id: 6,
          //     name: "agent",
          //   },
          // ];
          localStorage.setItem('jwtToken', response.data.access_token);
          localStorage.setItem('refreshJwtToken', response.data.refresh_token);

          if (roles.length === 1) {
            dispatch(setRoleName(roles[0].name));
            dispatch(setAvailableRoleList(roles));
            proceedAfterLogin(response, roles[0].name);
          } else {
            setAvailableRoles(roles);
            dispatch(setAvailableRoleList(roles));
            setShowRoleModal(true);
            return; // STOP FLOW HERE until user selects role
          }
          // login logic
          // dispatch(setRoleName(response.data.roles[0].name));
          // localStorage.setItem("jwtToken", response.data.access_token);
          // localStorage.setItem("lastActivity", Date.now().toString());
          // localStorage.setItem("refreshJwtToken", response.data.refresh_token);
          // localStorage.setItem("systemToken", response.data.session_id);
          // dispatch(setAuthInitialized(false));
          // dispatch(setUserStatus(response.data.status));
          // dispatch(setForcedPassword(response.data.enforce_password_reset));

          // setLoading(false);
          // dispatch(changeCardFalse());
          // const profileData = await getProfilePicture(
          //   response.data.access_token,
          // );
          // let haspendingTrining = false;
          // if (response.data.roles[0].name === "customer") {
          //   dispatch(setEDDStatus(profileData.has_pending_edd));
          // }
          // if (
          //   response.data.roles[0].name === "agency" ||
          //   response.data.roles[0].name === "agency_compliance"
          // ) {
          //   dispatch(setSurveyStatus(profileData.has_pending_survey));
          // }
          // if (
          //   response.data.roles[0].name === "agent" ||
          //   response.data.roles[0].name === "agency_compliance"
          // ) {
          //   dispatch(setPendingTraining(profileData.has_pending_training));
          // }
          // dispatch(setAuthInitialized(true));
          // const savedRedirect = sessionStorage.getItem("redirectAfterLogin");
          // if (savedRedirect) {
          //   console.log("saved url " + savedRedirect);

          //   const { path, state } = JSON.parse(savedRedirect);
          //   // Prevent active users going back to onboarding
          //   if (response.data.status === "active" && path === "/onboarding") {
          //     sessionStorage.removeItem("redirectAfterLogin");
          //     localStorage.setItem("sideOption", 1);
          //     navigate("/");
          //   } else {
          //     navigate(path, { state });
          //     sessionStorage.removeItem("redirectAfterLogin");
          //   }
          // } else {
          //   console.log("saved url no " + savedRedirect);

          //   if (response.data.status === "active") {
          //     navigate("/");
          //   } else {
          //     console.log(
          //       "Navigating to onboarding due to userStatus:",
          //       response.data.status,
          //     );
          //     navigate("/onboarding");
          //   }
          // }
          // Login end logic
        } else {
          toastMessage = { message: response.message, type: 'error' };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [authCode, sessionId, userId], // Dependencies
  );
  const sendCodeToverify = async (userId) => {
    let methodId = options.find((o) => o.id === selectedOption).id;

    const apiUrl = `${BASE_URL}/api/v1/auth/send-mfa-code`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
      method: methodId == 1 ? 'sms' : 'email',
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const SendCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message
      let methodId = options.find((o) => o.id === selectedOption).id;
      if (methodId != 3) {
        try {
          const response = await sendCodeToverify(userId);
          if (response.status == 200) {
            toastMessage = {
              message: 'OTP sent successfully!',
              type: 'success',
            };
            setEmailVerfied(true);
          } else {
            toastMessage = { message: response.message, type: 'error' };
            setEmailVerfied(false);
            return;
          }
        } catch (err) {
          toastMessage = { message: err.message, type: 'error' };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        setIsRecoveryCodeOption(true);
      }
    }, 1000),
    [userId, selectedOption, sessionId], // Dependencies
  );
  // Handle backspace
  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace' && !authCode[index] && index > 0) {
      document.getElementById(`code-input-${index - 1}`).focus();
    }
  };

  const handleChangeAuthCode = (value, index) => {
    if (/^\d*$/.test(value)) {
      // Only allow numbers
      const newOtp = [...authCode];
      newOtp[index] = value;
      setAuthCode(newOtp);
      if (value && index < 5) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
    }
  };
  const handleGuestLogin = () => {
    // You can redirect, open a limited guest view, or show a warning
    navigate('/add-stocks-guest'); // or open modal with guest info
  };
  const handleAppLogin = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message

      try {
        setFormSubmitted(false);
        setEmail('');
        setPassword('');
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [otp, userId], // Dependencies
  );
  return (
    <div className="flex  flex-col lg:flex-row h-screen dark:bg-[#101010] bg-[#FFFFFF]">
      <CustomerLeftPanel />
      <div className="w-full right-div lg:w-2/5 flex flex-col">
        {/* <ThemeSwitch /> */}
        <div className="dark:bg-[#101010]  bg-[#FAFAFA] flex justify-end py-[10px] px-[15px]">
          <button
            onClick={() => setIsSupportOpen(true)}
            className={`flex items-center bg-black  h-11 gap-2 px-3 py-2 text-xs rounded-xl transition-all duration-200 text-white shadow hover:scale-105`}
            style={{ background: '' }}
          >
            {/* Icon */}
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18 13a3 3 0 01-3 3h-1v-4h1a3 3 0 013 3zM6 13a3 3 0 003 3h1v-4H9a3 3 0 00-3 3z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3a9 9 0 00-9 9v3a3 3 0 003 3h1v-6H6a6 6 0 1112 0h-1v6h1a3 3 0 003-3v-3a9 9 0 00-9-9z"
              />
            </svg>

            {/* Text */}
            <span className="hidden sm:inline">Need Help?</span>
          </button>
        </div>

        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {isSupportOpen && (
          <div className="fixed inset-0 z-[20] flex items-center justify-center bg-black/40 backdrop-blur-sm">
            {/* Modal */}
            <ContactUs
              onClose={() => setIsSupportOpen(false)}
              isLogin={false}
            />
          </div>
        )}
        {formSubmitted ? (
          <div>
            {emailVerfied &&
              !showAppPopup &&
              !isRecoveryCodeOption &&
              !handshakeApproved && (
                <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                  <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                    Please Verify your{' '}
                    {options.find((o) => o.id === selectedOption).name}
                  </h2>

                  <form
                    className="w-full max-w-sm"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (otp.length < 6) {
                        showToast('Please Enter 6 digit OTP!', 'error'); // Success toast
                        return;
                      }
                      setLoading(true);
                      handleSubmitMobile(e);
                    }}
                  >
                    <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                      Please check your{' '}
                      {options.find((o) => o.id === selectedOption).name} for
                      the verification code we just sent you and enter the code
                      in the box below
                    </p>
                    <div className="mb-2">
                      <label
                        htmlFor="maskedData"
                        className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                      >
                        Code sent to:
                      </label>
                      <input
                        id="maskedData"
                        name="maskedData"
                        type="text"
                        value={`${
                          options.find((o) => o.id === selectedOption).label
                        }`}
                        required={true}
                        disabled={true}
                        className="input-field disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    </div>
                    <div className="mb-4 mt-10">
                      <OTPInputWithTimer
                        onOtpChange={(value) => setOtp(value)}
                        onLoadingChange={(value) => setLoading(value)}
                        initialTime={300}
                        userId={userId}
                        postCode={SendCode}
                      />
                    </div>

                    <button
                      type="submit"
                      className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] text-white rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}

            {!isAuthCode &&
              !showAppPopup &&
              isRecoveryCodeOption &&
              !handshakeApproved && (
                <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                  <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                    Log in to Ratified
                  </h2>

                  <form
                    className="w-full max-w-sm "
                    onSubmit={handleSubmitMobile}
                  >
                    <p className="text-sm  dark:text-white ">
                      Enter a recovery code to access your account. Recovery
                      codes are used when your phone is unavailable, and each
                      code can only be used once.
                    </p>
                    <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                      <img
                        src="/sms.svg"
                        alt="Success Icon"
                        className="h-6 w-6"
                      />
                      <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                        {email}
                      </p>
                    </div>
                    <div className="flex w-full flex-col items-center justify-between">
                      <div
                        onPaste={handlePaste}
                        className="flex w-full gap-2 mb-2 mt-8 flex-nowrap justify-between"
                      >
                        {authCode.map((digit, index) => (
                          <input
                            key={index}
                            id={`code-input-${index}`}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) =>
                              handleChangeAuthCode(e.target.value, index)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
          dark:bg-[#101010] ${
            digit ? 'border-[#003478]' : 'grey'
          } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
          input-main`}
                          />
                        ))}
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full mt-10  bg-[#003478] rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 transition duration-300"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}

            {isAuthCode && handshakeApproved && !showAppPopup && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Log in to Ratified
                </h2>

                <form
                  className="w-full max-w-sm "
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (authCode.join('').length < 6) {
                      showToast('Please Enter 6 digit Number!', 'error'); // Success toast
                      return;
                    }
                    setLoading(true);
                    handleSubmitAuthAppCode(e);
                  }}
                >
                  <p className="text-sm  dark:text-white ">
                    Enter the number displayed on the homepage of your Ratified
                    mobile app in the authentication section.
                  </p>
                  <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                    <img
                      src="/sms.svg"
                      alt="Success Icon"
                      className="h-6 w-6"
                    />
                    <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                      {email}
                    </p>
                  </div>
                  <div className="flex w-full flex-col items-center justify-between">
                    <div
                      onPaste={handlePaste}
                      className="flex w-full gap-2 mb-2 mt-8 flex-nowrap justify-between"
                    >
                      {authCode.map((digit, index) => (
                        <input
                          key={index}
                          id={`code-input-${index}`}
                          type="text"
                          maxLength="1"
                          value={digit}
                          onChange={(e) =>
                            handleChangeAuthCode(e.target.value, index)
                          }
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
            dark:bg-[#101010] ${
              digit ? 'border-[#003478]' : 'grey'
            } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
            input-main`}
                        />
                      ))}
                    </div>
                  </div>

                  {/* "Didn't get a code?" Section */}
                  <div className="flex items-center pt-4  mb-6 justify-between mb-6">
                    <div className="flex items-center"></div>
                    <a
                      href="#"
                      onClick={(e) => handletryRecoveryCode(e)}
                      className=" text-sm font-semibold text-decoration after-login hover:underline"
                    >
                      Use your Recovery Code
                    </a>
                  </div>
                  <button
                    type="submit"
                    className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#375AE7] text-white rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Submit
                  </button>
                </form>
              </div>
            )}
            {showRoleModal && (
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-md px-4">
                <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden animate-in fade-in slide-in-from-bottom-4">
                  {/* HEADER */}
                  <div className="p-6 border-b bg-gradient-to-r from-[#375AE7]/10 to-indigo-50">
                    <h2 className="text-lg font-semibold text-gray-900">
                      Choose Your Role
                    </h2>
                    <p className="text-sm text-gray-600 mt-1">
                      You have multiple roles. Select how you want to continue.
                    </p>
                  </div>

                  {/* BODY */}
                  <div className="p-4 space-y-3 max-h-[50vh] overflow-y-auto">
                    {availableRoles.map((role) => {
                      const config =
                        roleConfig[role.name] || roleConfig.customer;
                      const Icon = config.icon;

                      return (
                        <button
                          key={role.name}
                          onClick={(e) => {
                            setShowRoleModal(false);
                            setLoading(true);
                            handleUpdateSwtich(e, role.name, role.id);
                            //proceedAfterLogin(loginResponse, role.name);
                          }}
                          className={`
                w-full flex items-center justify-between
                p-4 rounded-xl border
                transition-all duration-200
                hover:shadow-md hover:scale-[1.01]
                ${config.bg} ${config.border}
              `}
                        >
                          {/* LEFT SIDE */}
                          <div className="flex items-center gap-3">
                            <div
                              className={`p-2 rounded-lg bg-white shadow-sm`}
                            >
                              <Icon className={`w-5 h-5 ${config.color}`} />
                            </div>

                            <div className="text-left">
                              <p className="font-semibold text-gray-800 capitalize">
                                {config.label}
                              </p>
                              <p className="text-xs text-gray-500">
                                Continue as {config.label.toLowerCase()}
                              </p>
                            </div>
                          </div>

                          {/* RIGHT */}
                          <CheckCircle2 className={`w-5 h-5 ${config.color}`} />
                        </button>
                      );
                    })}
                  </div>

                  {/* FOOTER */}
                  <div className="p-4 border-t bg-gray-50">
                    <button
                      onClick={() => setShowRoleModal(false)}
                      className="w-full text-sm text-gray-600 hover:text-gray-900 transition"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
            <AnimatePresence>
              {handshakeApproved &&
                !emailVerfied &&
                !isRecoveryCodeOption &&
                !isAuthCode &&
                !showAppPopup && (
                  <motion.div
                    key="Ratified-popup"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.4 }}
                    className="flex flex-col mt-10 justify-center items-center md:p-0 p-10"
                  >
                    <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                      <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                        Approve your Sign in
                      </h2>
                      <WebSocketComponent
                        userId={userId}
                        socketToken={socketToken}
                      />

                      <form
                        className="w-full max-w-sm "
                        onSubmit={handleSubmitMobile}
                      >
                        <p className="text-sm  dark:text-white ">
                          Use the number you see below in your Ratified Mobile
                          App to sign in
                        </p>
                        <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                          <img
                            src="/sms.svg"
                            alt="Success Icon"
                            className="h-6 w-6"
                          />
                          <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                            {email}
                          </p>
                        </div>
                        <div className="mt-6 mb-4 w-full max-w-sm  text-center text-4xl font-semibold text-black dark:text-white">
                          <span className="bg-[#F9F9F9] px-4 py-2 rounded">
                            {authAppCode}
                          </span>
                        </div>

                        {/* "Didn't get a code?" Section */}
                        <p className="text-md w-full max-w-sm text-center text-black font-medium">
                          Didn't get a code?
                        </p>
                        <div className="text-center w-full max-w-sm mt-4 space-y-3">
                          <a
                            href="#"
                            onClick={(e) => handletryAuthCode(e)}
                            className="text-sm text-[#003478] font-semibold underline block"
                          >
                            Try your Authentication Code Instead
                          </a>

                          <span className="text-black font-medium block">
                            -or-
                          </span>

                          <a
                            href="#"
                            onClick={(e) => handletryRecoveryCode(e)}
                            className="text-sm text-[#9C9C9C] font-semibold underline block"
                          >
                            Use your Recovery Code
                          </a>
                        </div>

                        <ResendOptions
                          handleResendCode={GetAuthCode}
                          autoStart={true}
                        />
                      </form>
                    </div>
                  </motion.div>
                )}
            </AnimatePresence>
            {emailStep && (
              <VerificationCode
                key="login-email-otp"
                email={email}
                verifyCode={(code) => verifyLoginOtpCode(code, 'email')}
                onResend={() => resendLoginOtpCode('email')}
                onVerify={handleLoginEmailVerified}
              />
            )}
            {mobileOtpStep && (
              <VerificationCode
                key="login-mobile-otp"
                channel="mobile"
                email={email}
                destination={loginMaskedPhone}
                verifyCode={(code) => verifyLoginOtpCode(code, 'sms')}
                onResend={() => resendLoginOtpCode('sms')}
                onVerify={handleLoginMobileVerified}
              />
            )}
            {!isAuthCode &&
              isRecoveryCodeOption &&
              handshakeApproved &&
              !showAppPopup &&
              !emailVerfied && (
                <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                  <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                    Log in to Ratified
                  </h2>

                  <form
                    className="w-full max-w-sm "
                    onSubmit={handleSubmitMobile}
                  >
                    <p className="text-sm  dark:text-white ">
                      Enter a recovery code to access your account. Recovery
                      codes are used when your phone is unavailable, and each
                      code can only be used once.
                    </p>
                    <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                      <img
                        src="/sms.svg"
                        alt="Success Icon"
                        className="h-6 w-6"
                      />
                      <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                        {email}
                      </p>
                    </div>
                    <div className="flex w-full flex-col items-center justify-between">
                      <div
                        onPaste={handlePaste}
                        className="flex w-full gap-2 mb-2 mt-8 flex-nowrap justify-between"
                      >
                        {authCode.map((digit, index) => (
                          <input
                            key={index}
                            id={`code-input-${index}`}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) =>
                              handleChangeAuthCode(e.target.value, index)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
          dark:bg-[#101010] ${
            digit ? 'border-[#003478]' : 'grey'
          } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
          input-main`}
                          />
                        ))}
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full mt-10  bg-[#003478] rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 transition duration-300"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}
            <AnimatePresence>
              {!emailVerfied &&
                !isRecoveryCodeOption &&
                !isAuthCode &&
                !handshakeApproved &&
                showAppPopup && (
                  <motion.div
                    key="Ratified-popup"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.4 }}
                    className="flex flex-col mt-10 justify-center items-center p-10 justify"
                  >
                    <form className="w-full max-w-md" onSubmit={handleAppLogin}>
                      {/* HEADER */}
                      <div className="text-center mb-8">
                        <span className="material-symbols-outlined text-3xl text-[#375AE7]">
                          smartphone
                        </span>

                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mt-2">
                          Get Started with Ratified App
                        </h2>

                        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                          Follow the steps below to install and access your
                          account
                        </p>
                      </div>

                      {/* MAIN CONTENT */}
                      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl p-6 space-y-6">
                        {/* STEP 1 */}
                        <div className="flex gap-4">
                          {/* STEP INDICATOR */}
                          <div className="flex flex-col items-center">
                            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#375AE7] text-white text-sm font-semibold">
                              1
                            </div>
                            <div className="w-px h-full bg-gray-200 dark:bg-gray-700 mt-2"></div>
                          </div>

                          {/* CONTENT */}
                          <div className="w-full">
                            <div className="flex items-center gap-2 mb-2">
                              <span className="material-symbols-outlined text-[#375AE7]">
                                download
                              </span>
                              <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                                Download Mobile Application
                              </h3>
                            </div>

                            {/* <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
          Install the Ratified mobile application using App Store or Google Play, or scan the QR code below.
        </p> */}
                            {isMobile ? (
                              <p className="text-sm mb-[32px] text-gray-600 dark:text-white mb-6">
                                Please press the below button to Download the
                                Ratified Authenticator App & Register for easy
                                access.
                              </p>
                            ) : (
                              <p className="text-sm mb-[32px] text-gray-600 dark:text-white mb-6">
                                Please scan the below QR code to Download the
                                Ratified Authenticator App & Register for easy
                                access.
                              </p>
                            )}

                            {/* STORE / QR */}
                            {!isMobile && (
                              <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                                {/* iOS */}
                                <div className="flex flex-col items-center">
                                  <div className="flex items-center gap-2 border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-1 bg-white dark:bg-gray-800">
                                    <img
                                      src="/apple-logo.svg"
                                      className="w-4 h-4"
                                    />
                                    <div className="leading-tight">
                                      <p className="text-[10px] text-gray-500">
                                        Download on the
                                      </p>
                                      <p className="text-sm font-medium text-gray-900 dark:text-white">
                                        App Store
                                      </p>
                                    </div>
                                  </div>

                                  <a
                                    href={IOSImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={IOSImage}
                                      alt="iOS QR"
                                      className="w-32 mt-3 rounded-md shadow-sm"
                                    />
                                  </a>
                                </div>

                                <span className="text-xs text-gray-400 hidden md:block">
                                  OR
                                </span>

                                {/* Android */}
                                <div className="flex flex-col items-center">
                                  <div className="flex items-center gap-2 border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-1 bg-white dark:bg-gray-800">
                                    <img
                                      src="/playstore-logo.svg"
                                      className="w-4 h-4"
                                    />
                                    <div className="leading-tight">
                                      <p className="text-[10px] text-gray-500">
                                        Get it on
                                      </p>
                                      <p className="text-sm font-medium text-gray-900 dark:text-white">
                                        Google Play
                                      </p>
                                    </div>
                                  </div>

                                  <a
                                    href={androidImage}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <img
                                      src={androidImage}
                                      alt="Android QR"
                                      className="w-32 mt-3 rounded-md shadow-sm"
                                    />
                                  </a>
                                </div>
                              </div>
                            )}

                            {isMobile && (
                              <div className="flex flex-col gap-4 w-full max-w-sm">
                                {/* iOS Button */}
                                <a
                                  href="https://apps.apple.com/au/app/ratified/id6758427905"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex items-center justify-center gap-3 border rounded-xl py-3 px-4 bg-black text-white shadow-md hover:opacity-90 transition"
                                >
                                  <span className="material-symbols-outlined text-xl text-white">
                                    phone_iphone
                                  </span>

                                  <div className="text-left leading-tight">
                                    <p className="text-[10px] opacity-80">
                                      Download on the
                                    </p>
                                    <p className="text-sm font-semibold">
                                      App Store
                                    </p>
                                  </div>
                                </a>

                                {/* Android Button */}
                                <a
                                  href="https://play.google.com/store/apps/details?id=com.ratified&pcampaignid=web_share"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex items-center justify-center gap-3 border rounded-xl py-3 px-4 bg-[#1a73e8] text-white shadow-md hover:opacity-90 transition"
                                >
                                  <span className="material-symbols-outlined text-xl text-white">
                                    android
                                  </span>

                                  <div className="text-left leading-tight">
                                    <p className="text-[10px] opacity-80">
                                      Get it on
                                    </p>
                                    <p className="text-sm font-semibold">
                                      Google Play
                                    </p>
                                  </div>
                                </a>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* STEP 2 */}
                        <div className="flex gap-4 pt-5 border-t border-gray-200 dark:border-gray-700">
                          {/* STEP INDICATOR */}
                          <div className="w-12 h-6 flex items-center justify-center rounded-full bg-[#22c55e] text-white text-sm font-semibold">
                            2
                          </div>

                          {/* CONTENT */}
                          <div>
                            <div className="flex items-center gap-2 mb-2">
                              <span className="material-symbols-outlined text-green-600">
                                lock
                              </span>
                              <h3 className="text-base font-semibold text-gray-900 dark:text-white">
                                Login to Mobile App
                              </h3>
                            </div>

                            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                              Use the same{' '}
                              <span className="font-semibold text-green-600">
                                email address and password
                              </span>{' '}
                              used on the web platform to securely access the
                              mobile application.
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* CTA */}
                      {/* <button
    type="submit"
    className="w-full mt-6 bg-[#375AE7] hover:bg-[#2f4fd1] text-white font-medium py-3 rounded-full flex items-center justify-center gap-2 transition"
  >
    <img src="/arrow-left-password.svg" className="w-4 h-4" />
    Back to Login
  </button> */}
                      <button
                        type="submit"
                        className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-white rounded-full text-black font-medium text-md py-3 border-2 border-black flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                      >
                        <img
                          src="/arrow-left-password.svg" // Replace with the correct path to your icon image
                          alt="Icon"
                          className="w-4 h-4" // Adjust size as needed
                        />
                        Back To Log in
                      </button>
                    </form>
                  </motion.div>
                )}
            </AnimatePresence>
          </div>
        ) : (
          <div>
            <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
              <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                Log in to Ratified
              </h2>
              <form
                className="w-full max-w-sm"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!validateEmail(email)) {
                    showToast('Please Enter a Valid email!', 'error');
                    return;
                  }
                  setLoading(true);
                  handleSubmit(e);
                }}
              >
                <div className="mb-4">
                  <label
                    htmlFor="email"
                    className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                  >
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="text"
                    value={email}
                    required={true}
                    placeholder="name@gmail.com"
                    className="input-field dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-4 relative">
                  <label
                    htmlFor="password"
                    className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                  >
                    Password
                  </label>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    required={true}
                    id="password"
                    onChange={(e) => setPassword(e.target.value)}
                    className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Type password"
                  />
                  <button
                    type="button"
                    onClick={togglePassword}
                    className="absolute right-3 set-top"
                  >
                    {' '}
                    {showPassword ? (
                      <img src="/eye.svg" alt="Logo" className="h-auto" />
                    ) : (
                      <img src="/eye-slash.svg" alt="Logo" className="h-auto" />
                    )}
                  </button>
                  <div className="flex items-center pt-4 justify-between mb-6">
                    <div className="flex items-center"></div>
                    <a
                      onClick={() => {
                        navigate('/forgot-password', {
                          state: {
                            from: location.pathname,
                            isForced: false,
                          },
                        });
                      }}
                      href="#"
                      className=" text-sm font-medium  after-login hover:underline"
                    >
                      Forgot Password?
                    </a>
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-[#1E201D] text-white rounded-full text-white font-medium text-md py-3  flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                >
                  <img
                    src="/profile-circle-white.svg"
                    alt="Login Icon"
                    className="h-6 w-6"
                  />
                  Login
                </button>
              </form>
              <div className="mt-6 w-full max-w-sm text-center">
                <img src="/line.svg" alt="Logo" className="h-auto" />

                <p className="text-labelColour dark:text-[#CCCCCC] font-medium pt-2">
                  Don't have an account?{' '}
                  <button
                    type="submit"
                    disabled={false}
                    onClick={() => {
                      // window.location.href =
                      //   "https://map.merchant.Ratified.com.au/sign-up";
                      navigate('/sign-up');
                    }}
                    className="w-full dark:bg-[#101010] dark:text-white dark:border-[#424242] mt-2 signup-button text-black font-medium text-sm py-3 rounded flex items-center justify-center gap-2 hover:bg-[#F1F5F9] dark:hover:bg-[#1E293B]  transition duration-300"
                  >
                    <img
                      src="/user-circle-add.svg"
                      alt="Login Icon"
                      className="h-6 w-6 dark:hidden"
                    />
                    Sign up
                  </button>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
